import { produce } from 'immer';

import { ChangeImportMode } from '../../actions/importWizard/changeImportMode';
import { ImportWizardState } from '../../typings/importWizard';

export function changeImportMode(state: ImportWizardState, action: ChangeImportMode): ImportWizardState {
    return produce(state, draft => {
        draft.importMode = action.importMode;
    });
}
